/** info-page (tabs) */

<template>
    <div>
        <ul class="rc-info-tabs">
            <li v-for="(tab, key) in tabRefs" v-bind:class="{'active': tab.visible, 'striped-link-on': tab.visible, 'striped-link': !tab.visible}">
                <a v-on:click.prevent="switchTab(key)" role="button" tabindex="0">
                    {{ tab.tabName }}
                </a>
            </li>
        </ul>

        <div class="rc-info-content">
            <div v-for="tab in tabRefs" style="position: relative">

                <div v-bind:id="tab.external" v-show="tab.visible"></div>

                <content-editor start-height="250"
                                v-bind:update-url="updateUrl"
                                v-bind:instance-id="tab.action"
                                v-bind:action="tab.action"
                                v-bind:display-id="tab.external"
                                v-bind:allow-embeds="true"
                                v-if="userAuthenticated" v-show="tab.visible">
                </content-editor>
            </div>
<!--        <div id="leader-text" class="link-styles">{{ leader_text|safe }}</div>-->



        </div>
    </div>
</template>


<script>
import ContentEditor from "../common-components/content-editor.vue";

export default {
    name: "info-page",
    components: {
        ContentEditor
    },
    props: {
        userAuthenticated: {type: Boolean, default: false}
    },
    data: function () {
        return {
            tabRefs: {
                "rc": {
                    tabName: "About the Reality Check", visible: true, action: "update_about",
                    local: "reality-check-content", external: "reality-check"
                },
                "managing": {
                    tabName: "Managing MPAs", visible: false, action: "update_managing",
                    local: "managing-mpas-content", external: "managing-mpas"
                },
                "offshore": {
                    tabName: "Offshore", visible: false, action: "update_offshore",
                    local: "offshore-content", external: "offshore"
                },
                "ifcas": {
                    tabName: "Work of the IFCAs", visible: false, action: "update_ifcas",
                    local: "ifcas-content", external: "ifcas"
                },
                "updates": {
                    tabName: "Most recent updates", visible: false, action: "update_recent_updates",
                    local: "updates-content", external: "updates"
                },
                "recovery_check": {
                    tabName: "MPA Recovery Check", visible: false, action: "update_recovery_check",
                    local: "recovery-check-content", external: "recovery_check"
                }
            }
            // showRc: false,
            // showManaging: false,
            // showOffshore: false,
            // showIfcas: false,
            // showUpdates: false,

        }
    },
    methods: {
        switchTab: function (newTab) {
            for (let key in this.tabRefs) {
                this.tabRefs[key].visible = key === newTab;
            }
        }
    },
    computed: {
        updateUrl: function () {
            return mparc.urls.updateRealityCheckContent;
        }
    },
    watch: {},
    mounted: function () {
        for (let key in this.tabRefs) {
            const block = document.querySelector("#" + this.tabRefs[key].local);
            block.classList.remove("temporarily-hidden");
            document.querySelector("#" + this.tabRefs[key].external).innerHTML = block.innerHTML;
            block.remove();
        }
    }
}
</script>


<style lang="scss">
    @import "../../styles/variables.scss";

    .rc-info-tabs {
        list-style: none;
        margin: 0 0 20px 0;
        padding: 0;

        li {
            display: inline-block;
            margin-right: 25px;
            color: $main-text-color !important;
            font-weight: normal;
        }

        .active {
            font-weight: bold;

            a {
                cursor: auto;
            }
        }

        a {
            cursor: pointer;
        }

    }

    .rc-info-content {

    }


</style>